export const FTS_MONTHLY = 'ftsMonthly';

export const FTS_MONTHLY_ACTIONS_NAME = {
  searchTableData: `${FTS_MONTHLY}/searchTableData`,
} as const;

export const FTS_MONTHLY_MUTATIONS_NAME = {
  setTableData: `${FTS_MONTHLY}/setTableData`,
} as const;

export const FTS_MONTHLY_GETTERS_NAME = {
  getTableData: `${FTS_MONTHLY}/getTableData`,
} as const;
